import React from 'react';
import { styled } from '@mui/material/styles';

// START META DATA
const MetaWrapper = styled('div')(() => ({
  display: 'flex',
  flexWrap: 'wrap',
  padding: '16px',
  gap: 'var(--card-spacing-2)',
}));

const MetaData = styled('p')(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: 'var(--card-spacing-2)',
}));

const MetaText = styled('a')(() => ({
  padding: 'var(--card-spacing-1) var(--card-spacing-2)',
  fontSize: '0.75rem',
  lineHeight: '0.75rem',
  borderRadius: 'var(--card-radius-1)',
  textDecoration: 'none',
  fontSize: '10px',
  padding: '6px',
  color: 'white !important',
}));

const TypeMeta = styled(MetaText)(() => ({
  color: 'var(--dark-green)',
  backgroundColor: 'var(--light-green)',

  '&:hover': {
    backgroundColor: 'var(--green)',
  },
}));

const CategoryMeta = styled(MetaText)(() => ({
  color: 'var(--dark-blue)',
  backgroundColor: 'var(--light-blue)',

  '&:hover': {
    backgroundColor: 'var(--blue)',
  },
}));

const CompanyMeta = styled(MetaText)(() => ({
  color: 'var(--dark-purple)',
  backgroundColor: 'var(--light-purple)',

  '&:hover': {
    backgroundColor: 'var(--purple)',
  },
}));

const PlatformMeta = styled(MetaText)(() => ({
  color: 'var(--dark-grey)',
  backgroundColor: 'var(--light-primary-green) !important',

  '&:hover': {
    backgroundColor: 'var(--dark-primary-green) !important',
  },
}));
// END META DATA

const ToolMetaData = ({
  type,
  categories = [],
  company = [],
  platform = [],
}) => {
  return (
    <MetaWrapper>
      {type && (
        <MetaData>
          <TypeMeta>{type}</TypeMeta>
        </MetaData>
      )}

      {categories.length > 0 &&
        categories.map((category, index) => (
          <MetaData key={index}>
            <CategoryMeta>{category.name}</CategoryMeta>
          </MetaData>
        ))}

      {company &&
        company.length > 0 &&
        company.map((company, index) => (
          <MetaData key={index}>
            <CompanyMeta>{company.name}</CompanyMeta>
          </MetaData>
        ))}

      {platform.length > 0 &&
        platform.map((platform, index) => (
          <MetaData key={index}>
            <PlatformMeta>{platform.name}</PlatformMeta>
          </MetaData>
        ))}
    </MetaWrapper>
  );
};

export default ToolMetaData;
